import { planMatch } from '@app-core/utils/plan-utils';
import { ProductFilters } from '@app-model/filters/product-filters';
import { ProductFilter } from '@app-model/index';
import { ProductItem } from '@app-model/response';

export function filterProducts(filters: ProductFilters, productItems: ProductItem[]): ProductItem[] {
  let filteredProducts = productItems;
  const enabledFilters: (keyof ProductFilters)[] = ['product', 'plan', 'deductible', 'term', 'mileage'];
  for (let i = 0; i < enabledFilters.length; i++) {
    filteredProducts = _filterBy(enabledFilters[i], filters, filteredProducts);
    if (i + 1 < enabledFilters.length) {
      _hideInconsequentialFilters(enabledFilters[i + 1], filters, filteredProducts);
    }
  }

  return filteredProducts;
}

function _match(property: keyof ProductFilters, product: ProductItem, filter: ProductFilter) {
  switch (property) {
    case 'product':
      return filter.name === product.productDescription.enUsProductDescription;
    case 'plan':
      return planMatch(filter, product);
    case 'deductible':
      return filter.name == product.deductible + (product.disappearingDeductible ? '(D)' : '');
    case 'term':
      return filter.name == product.maxTerm;
    case 'mileage':
      return filter.name == product.termMileage;
    default:
      console.warn(`Unrecognized category key (${property}) passed to _match function`);
  }
}

function _filterBy(
  property: keyof ProductFilters,
  filters: ProductFilters,
  productsToFilter: ProductItem[]
): ProductItem[] {
  const selectedFilters = filters[property].filter((filter) => filter.selected);
  if (!selectedFilters.length) {
    return productsToFilter;
  }

  return productsToFilter.filter((product) => {
    return selectedFilters.find((filter) => _match(property, product, filter));
  });
}

function _hideInconsequentialFilters(property: keyof ProductFilters, filters: ProductFilters, products: ProductItem[]) {
  filters[property].forEach((filter) => {
    filter.display = filter.selected || !!products.find((product) => _match(property, product, filter));
  });
}
